import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { DefaultsService } from '../services/defaults.service'
import * as actions from '../store/defaults.actions'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { IDefaultsResponse } from '../store/defaults.types'

export function* setProcedureDefaults() {
  const serviceId: string = yield select(getServiceIdSelector)
  const defaultsService = new DefaultsService(serviceId)
  try {
    const response: IDefaultsResponse = yield call([defaultsService, defaultsService.getProcedureDefaults])
    const { entity } = response
    if (entity) yield put(actions.setProcedureDefaults(entity))
  } catch (e) {
    yield put(throwPcrException(`setProcedureDefaults() error: ${e}`))
  }
}
export function* setProcedureDefaultsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setProcedureDefaults)
}
